import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CustomAvatar from 'components/CustomAvatar/CustomAvatar';
import Business from '@material-ui/icons/BusinessOutlined';
import { BodyS, Caption, HeadingLBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CardBody from 'components/Card/CardBody';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';
import Badge from 'components/Badge/Badge';
import GridItem from 'components/Grid/GridItem';
import React, { useMemo } from 'react';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/accountsStyle';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleOrganizationProps {
	account: SingleCorpAccount;
	departments: SingleDepartment[];
}

const SingleOrganization = ({ account, departments }: ISingleOrganizationProps) => {
	const classes = useStyles();
	const history = useHistory();

	const showDetails = () => history.push(`organizations/${account.accountId}`);

	const filteredDepartments = useMemo(() => {
		return departments.filter((department) => department.accountId === account.accountId);
	}, [departments, account]);

	return (
		<GridItem xs={12} sm={6} key={account.accountId}>
			<Card data-test-id={`organization-${account.accountId}`} className={classes.card} onClick={showDetails}>
				<>
					<CardHeader icon color="white">
						<>
							<CardIcon color="white" size="lg">
								<CustomAvatar
									accountId={account.accountId}
									alt="Organization card icon"
									placeholderIcon={<Business />}
								/>
							</CardIcon>

							<div className={classes.headerCaption}>
								<BodyS color="secondary-light" disableMargin>
									{translate('organizations.account.name')}
								</BodyS>
							</div>
							<HeadingLBold color="primary-light">{account.accountName}</HeadingLBold>
						</>
					</CardHeader>
					<CardBody className={classes.cardBody}>
						<div className={classes.bodyCaption}>
							<BodyS color="secondary-light" disableMargin>
								{translate('departments')}
							</BodyS>
						</div>
						<>
							{filteredDepartments.map((department: SingleDepartment) => (
								<Badge
									key={department.deptId}
									hexColor={department.uiColor}
									filled
									className={classes.departmentBadge}
								>
									{department.name}
								</Badge>
							))}
							{filteredDepartments.length === 0 && (
								<div className={classes.noDepartments}>
									<Caption color="disabled-light">{translate('accounts.no.departments')}</Caption>
								</div>
							)}
						</>
					</CardBody>
				</>
			</Card>
		</GridItem>
	);
};

export default SingleOrganization;
